const pagesPoLedgerEn = {
  amountCostAdjustment: 'Cost Adjustment',
  amountGrandTotalInclTax: 'Grand Total (incl. tax)',
  amountSubtotalExclTax: 'Item Subtotal (excl. tax)',
  amountTotalTax: 'Tax',
  detailNavTitle: 'Basic Information',
  detailTabsBasicInfo: 'Basic Information',
  detailTabsLines: 'PO Lines',
  drawerClose: 'Close',
  drawerFieldAcceptedQty: 'Accepted Qty',
  drawerFieldInvoicedQty: 'Invoice Received Qty',
  drawerFieldOpenOrderQty: 'Open Order Qty',
  drawerFieldOrderedQty: 'Ordered Qty',
  drawerFieldReceivedQty: 'Received Qty',
  drawerFieldRemainingInvoiceQty: 'Remaining Invoice Qty',
  drawerFieldRemainingReceiptQty: 'Remaining Receipt Qty',
  drawerFieldSupplierConfirmedQty: 'Supplier Confirmed Qty',
  drawerLedgerGoodsReceipt: 'Goods Receipt Ledger',
  drawerLedgerInspection: 'Inspection Ledger',
  drawerLedgerInvoice: 'Invoice Ledger',
  drawerNoProgressNote: 'No fulfillment axis exists yet because the PO is not confirmed (all values shown as "—").',
  drawerNotIntegratedNote: 'Actuals are not yet available because the external integration is not implemented (0 does not mean "nothing received").',
  drawerOrigin: {
    ACTUAL: 'Actual',
    CALCULATED: 'Calculated',
    PROMISED: 'Promised'
  },
  drawerSectionProgress: 'Reconciliation Quantities',
  drawerTitle: 'Line Details',
  fieldAcceptanceCriteria: 'Acceptance Criteria',
  fieldApprover: 'Approver',
  fieldBankFeeResponsibility: 'Bank Fee Responsibility',
  fieldBaseCurrencyCode: 'Accounting Base Currency',
  fieldBillFromName: 'Bill From',
  fieldBillToName: 'Bill To',
  fieldBudgetCode: 'Budget Code',
  fieldBudgetFiscalYear: 'Budget Fiscal Year',
  fieldBudgetPeriod: 'Budget Period',
  fieldBuyerName: 'Buyer Contact',
  fieldCollectToName: 'Collect To',
  fieldContract: 'Applicable Contract',
  fieldCostCenter: 'Cost Center',
  fieldCurrencyCode: 'Currency',
  fieldCurrentRevision: 'Current Revision',
  fieldDeliveryDueDate: 'Delivery Due Date',
  fieldDraftedBy: 'Drafted By',
  fieldGlAccountCode: 'GL Account Code',
  fieldIncoterms: 'Delivery Terms (Incoterms)',
  fieldOrderDate: 'Order Date',
  fieldOrderingPartyName: 'Ordering Party',
  fieldPayToCountry: 'Pay To Country',
  fieldPayToName: 'Pay To',
  fieldPaymentBaseDateType: 'Payment Base Date Type',
  fieldPaymentMethod: 'Payment Method',
  fieldPaymentSite: 'Payment Site',
  fieldPaymentTc: 'Payment Terms',
  fieldPoName: 'PO Title',
  fieldPoNumber: 'PO Number',
  fieldPoPriority: 'Priority',
  fieldPoStatus: 'PO Status',
  fieldPoSubtypes: 'Purchase Item',
  fieldPoType: 'PO Type',
  fieldProcurementMethod: 'Procurement Method',
  fieldProfitCenter: 'Profit Center',
  fieldPurchasingGroup: 'Purchasing Group',
  fieldPurchasingOrganization: 'Purchasing Organization',
  fieldQualifiedInvoiceRegistrationNumber: 'Qualified Invoice Registration Number',
  fieldRequesterCostCenter: 'Requester Cost Center',
  fieldRequesterName: 'Requester',
  fieldRequestingDepartment: 'Requesting Department',
  fieldShipFromName: 'Ship From',
  fieldShipToName: 'Ship To',
  fieldSupplierBpCode: 'BP Code',
  fieldSupplierCategory: 'Supplier Category',
  fieldSupplierContactDepartment: 'Department',
  fieldSupplierContactEmail: 'Email',
  fieldSupplierContactId: 'Contact ID',
  fieldSupplierContactIsActive: 'Active',
  fieldSupplierContactIsPrimary: 'Primary Contact',
  fieldSupplierContactLanguage: 'Language',
  fieldSupplierContactMobile: 'Mobile',
  fieldSupplierContactName: 'Contact Name',
  fieldSupplierContactPhone: 'Phone',
  fieldSupplierContactRole: 'Contact Role',
  fieldSupplierContactTitle: 'Job Title',
  fieldSupplierCreditStatus: 'Credit Status',
  fieldSupplierName: 'Supplier Name',
  fieldSupplierStatus: 'Supplier Status',
  fieldTaxClassification: 'Tax Classification',
  fieldTransactionCurrencyCode: 'Transaction Currency',
  fieldUpdatedAt: 'Updated At',
  fieldValidPeriod: 'PO Validity Period',
  fieldWithholdingTaxApplicable: 'Withholding Tax Applicable',
  headerApprovedAt: 'Approved On',
  headerApprover: 'Approver',
  headerGrandTotal: 'Grand Total',
  lineColumnItem: 'Item',
  lineColumnLineAmount: 'Line Total (Excl. Tax)',
  lineColumnLineNo: 'Line No.',
  lineColumnLineStatus: 'Fulfillment Status',
  lineColumnNetUnitPrice: 'Net Unit Price',
  lineColumnPromisedDeliveryDate: 'Promised Delivery Date',
  lineColumnQuantity: 'Quantity',
  lineColumnUnit: 'Unit',
  lineStatus: {
    CANCELLED: 'Cancelled',
    FULLY_RECEIVED: 'Fully Received',
    NOT_RECEIVED: 'Not Received',
    PARTIALLY_RECEIVED: 'Partially Received'
  },
  linesEmpty: 'No PO lines',
  listFilterAdvanced: 'Advanced Filters',
  listFilterClearAll: 'Clear all',
  listFilterDeliveryDueDate: 'Delivery Due Date',
  listFilterDeliveryDueDateFrom: 'Delivery Due Date (From)',
  listFilterDeliveryDueDateTo: 'Delivery Due Date (To)',
  listFilterOrderDate: 'Order Date',
  listFilterOrderDateFrom: 'Order Date (From)',
  listFilterOrderDateTo: 'Order Date (To)',
  listFilterPlaceholder: 'Search by PO title, PO number, or supplier...',
  listFilterPoMode: 'PO Mode',
  listFilterPoSubtype: 'Purchase Item',
  listFilterPoType: 'PO Type',
  listFilterPriority: 'Priority',
  listFilterProcurementCategory: 'Procurement Category',
  listFilterRangeEnd: 'End',
  listFilterRangeStart: 'Start',
  listPageTabPoList: 'PO List',
  listPageTitle: 'Purchase Order Ledger',
  poMode: {
    DIRECT_ORDER: 'Direct Order',
    EMERGENCY: 'Emergency',
    NORMAL: 'Normal',
    URGENT: 'Urgent'
  },
  poStatus: {
    APPROVED: 'Approved',
    CANCELLED: 'Cancelled',
    CHANGE_REQUESTED: 'Change Requested',
    CONFIRMED: 'Confirmed',
    DRAFT: 'Draft',
    EXPIRED: 'Expired',
    ON_HOLD: 'On Hold',
    OPEN: 'Open',
    RELEASED: 'Released',
    SUBMITTED: 'Submitted',
    VOIDED: 'Voided'
  },
  poSubtype: {
    CAPITAL_ASSET: 'Capital Asset',
    GOODS: 'Goods',
    SERVICES: 'Services'
  },
  poType: {
    BLANKET_RELEASE: 'Blanket Release',
    CONTRACT_BASED: 'Contract-based',
    FRAME_RELEASE: 'Frame Release',
    SPOT: 'Spot'
  },
  priority: {
    CRITICAL: 'Critical',
    HIGH: 'High',
    LOW: 'Low',
    NORMAL: 'Normal'
  },
  procurementCategory: {
    CAPITAL: 'Capital',
    DIRECT: 'Direct',
    INDIRECT: 'Indirect',
    IT: 'IT',
    MRO: 'MRO',
    SERVICES: 'Services'
  },
  procurementMethod: {
    CATALOG_ORDER: 'Catalog Order',
    COMPETITIVE: 'Competitive',
    DIRECT_NEGOTIATION: 'Direct Negotiation',
    SOLE_SOURCE: 'Sole Source'
  },
  sectionAccounting: 'Accounting & Budget Allocation',
  sectionIdentification: 'Identification & Status',
  sectionOrdering: 'Ordering',
  sectionSupplier: 'Supplier',
  sectionSupplierContact: 'Supplier Contact',
  sectionTerms: 'Terms',
  segmentAll: 'All',
  segmentAwaitingSupplier: 'Awaiting Supplier',
  segmentClosed: 'Closed',
  segmentConfirmed: 'Confirmed',
  segmentDrafting: 'Drafting & Approval',
  segmentNeedsAction: 'Needs Action',
  valueNo: 'No',
  valueYes: 'Yes'
};
export default pagesPoLedgerEn;